import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import EditIcon from 'core-system/Icons/Svg/Edit.svg'
import styled from 'styled-components'

const EditIconButton = styled(IconButton)`
  margin: 0 !important;
  padding: 0.2rem !important;
`

interface EditButtonProps {
  onClick: () => void
}

const EditButton = ({ onClick }: EditButtonProps) => {
  return (
    <EditIconButton onClick={onClick}>
      <Tooltip title='Edit'>
        <img src={EditIcon} alt='Edit' />
      </Tooltip>
    </EditIconButton>
  )
}

export default React.memo(EditButton)
